import { render, staticRenderFns } from "./Caraousel.vue?vue&type=template&id=50ff84c2"
import script from "./Caraousel.vue?vue&type=script&lang=js"
export * from "./Caraousel.vue?vue&type=script&lang=js"
import style0 from "./Caraousel.vue?vue&type=style&index=0&id=50ff84c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports